<div id="csi-header">
  @if (breadcrumbs?.length > 0) {
    <div class="csi-contracts__breadcrumb">
      @for (item of breadcrumbs; track item; let index = $index) {
        <span [routerLink]="item.route" [class.pointer]="item.route">{{ item.label | translate }}</span>
        @if (index !== breadcrumbs.length - 1) {
          <span><i class="ph ph-caret-right px-2"></i></span>
        }
      }
    </div>
    <div class="csi-contracts__title">
      @if (header) {
        {{ header | translate }}
      } @else {
        <p-skeleton width="15rem" height="2rem" styleClass="mb-2" />
      }
    </div>
    <div class="d-flex justify-content-between">
      <div class="csi-contracts__description">
        @if (description) {
          {{ description | translate }}
        }
      </div>

      @if (sortBtnLabel) {
        <span class="sort-btn" (click)="menu.toggle($event)">
          {{ sortBtnLabel | translate }}
          <i class="ph ph-sort-ascending icon"></i>

          <p-menu #menu [model]="sortMenus" [popup]="true" appendTo="body">
            <ng-template pTemplate="item" let-item>
              <span class="p-menu-item-link" [class.selected]="item.selected" (click)="onMenuClick($event, item)">
                {{ item.label | translate }}
              </span>
            </ng-template>
          </p-menu>
        </span>
      }
    </div>
  }
</div>
